var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.5,
    r: 20,
    fill: "#EEFFFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 20.0625L12.25 26.021L18.75 31.979M25.25 13.021L31.75 19.521L25.25 26.021",
    stroke: "#0FAA8E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9085 27.4835C17.0368 27.6455 17.2022 27.7743 17.3906 27.8591C17.5791 27.944 17.7851 27.9823 17.9915 27.971H18.6415C18.9289 27.971 19.2044 27.8568 19.4076 27.6537C19.6108 27.4505 19.725 27.1749 19.725 26.8875C19.725 26.6001 19.6108 26.3245 19.4076 26.1214C19.2044 25.9182 18.9289 25.804 18.6415 25.804H17.9375C17.7933 25.8071 17.6499 25.7814 17.5158 25.7283C17.3816 25.6753 17.2594 25.596 17.1563 25.4951C17.0533 25.3942 16.9714 25.2737 16.9154 25.1408C16.8595 25.0078 16.8307 24.865 16.8307 24.7208C16.8307 24.5765 16.8595 24.4337 16.9154 24.3007C16.9714 24.1678 17.0533 24.0473 17.1563 23.9464C17.2594 23.8455 17.3816 23.7662 17.5158 23.7132C17.6499 23.6601 17.7933 23.6344 17.9375 23.6375H18.5875C18.7952 23.6139 19.0055 23.6467 19.1962 23.7324C19.3869 23.8182 19.5509 23.9538 19.671 24.125M18.2625 23.0415V28.4585M27.4165 21.146C27.2803 21.3166 27.1072 21.4539 26.9101 21.5477C26.713 21.6416 26.4972 21.6893 26.279 21.6875C26.0867 21.6883 25.8962 21.651 25.7184 21.5778C25.5406 21.5046 25.379 21.3969 25.2431 21.2609C25.1071 21.125 24.9994 20.9634 24.9262 20.7856C24.853 20.6078 24.8157 20.4173 24.8165 20.225V18.8165C24.8157 18.6242 24.853 18.4337 24.9262 18.2559C24.9994 18.0781 25.1071 17.9166 25.2431 17.7806C25.379 17.6446 25.5406 17.5369 25.7184 17.4637C25.8962 17.3905 26.0867 17.3532 26.279 17.354C26.4963 17.358 26.7102 17.4085 26.9064 17.502C27.1025 17.5955 27.2765 17.7298 27.4165 17.896M24.1665 18.925H26.0085M24.1665 20.0085H26.0085",
    stroke: "#0FAA8E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/currency.2c22798a37b1ecf894f76dfc74b82850.svg";
export { ForwardRef as ReactComponent };